import { useEffect, useState } from 'react';
import { createFileRoute, redirect, useRouter } from '@tanstack/react-router';
import { client } from '@/lib/appwrite';
import EditCollaborator from '@/directory/EditCollaborator';
import { getUserWithProfile, type CombinedUser } from '@/lib/collections/workerProfile-Users/getUserWithProfile';

export const Route = createFileRoute('/_authenticated/directory/$id/edit')({
  beforeLoad: ({ context }) => {
    if (!context.user) throw redirect({ to: '/login' });

    // Solo RRHH y Admin pueden acceder
    if (!context.userRoles.isRRHH && !context.userRoles.isAdmin) {
      throw redirect({ to: '/unauthorized' });
    }
  },
  loader: async ({ params }) => {
    const user = await getUserWithProfile(params.id);
    if (!user) throw new Response('Not Found', { status: 404 });
    return user;
  },
  component: EditPage,
});

function EditPage() {
  const router = useRouter();
  const initialUser = Route.useLoaderData() as CombinedUser;
  const [_user, _setUser] = useState<CombinedUser>(initialUser);

  useEffect(() => {
    const dbId = import.meta.env.VITE_APPWRITE_DATABASE_ID!;
    const usersCol = import.meta.env.VITE_APPWRITE_USERS_COLLECTION_ID!;
    const profileCol = import.meta.env.VITE_WORKER_PROFILE_COLLECTION_ID!;

    const userChannel =
      `databases.${dbId}.collections.${usersCol}.documents.${initialUser.id}`;
    const profileChannel =
      `databases.${dbId}.collections.${profileCol}.documents.${initialUser.profile!.$id}`;

    const handler = async () => {
      // invalidar loader para refetch
      await router.invalidate();
    };

    const unsubUser = client.subscribe(userChannel, handler);
    const unsubProfile = client.subscribe(profileChannel, handler);

    return () => {
      unsubUser();
      unsubProfile();
    };
  }, [initialUser.id, initialUser.profile!.$id, router]);

  // Mientras router.invalidate recarga loader, el componente se re-monta con nuevo initialUser
  // Para forzar re-render, simple: usar user de loader
  const refreshedUser = Route.useLoaderData() as CombinedUser;

  return <EditCollaborator user={refreshedUser} />;
}
